import { LedgerId } from "@hashgraph/sdk";
import { HederaNetwork } from "../models/blade";
import { getBladeExtension } from "../helpers/interface-helpers";
import { getAccountIDsFromSigners } from "../helpers/utils";
import { WalletConnectStrategy } from "../strategies/wallet-connect.strategy";
export class ExtensionStrategy extends WalletConnectStrategy {
    async wakeExtension() {
        const extensionInterface = await getBladeExtension();
        if (extensionInterface && typeof extensionInterface.wake === "function") {
            return await extensionInterface.wake();
        }
        return true;
    }
    async createSession(params) {
        const extension = await getBladeExtension();
        if (extension) {
            const networkName = ((params === null || params === void 0 ? void 0 : params.network) || HederaNetwork.Mainnet).toLowerCase();
            const data = await this.dAppConnector.prepareConnectURI(LedgerId.fromString(networkName));
            if (data) {
                await extension.pairWC(data.uri);
                const session = await data.approval();
                await this.onSessionChange(session);
                return getAccountIDsFromSigners(this.signers);
            }
            else {
                const existingSession = await this.dAppConnector.checkPersistedState();
                if (existingSession) {
                    await this.onSessionChange(existingSession);
                    return getAccountIDsFromSigners(this.signers);
                }
                return [];
            }
        }
        return [];
    }
}
